import React from 'react';
import {Link} from 'react-router-dom';
import styles from './Breadcrumbs.module.css';

const Breadcrumbs = ({items = []}) => (
    <nav className={styles.breadcrumbs} aria-label="Хлебные крошки">
        <Link to="/">Главная</Link>
        {items.map((item) => (
            item.to
                ? <Link key={item.label} to={item.to}>{item.label}</Link>
                : <span key={item.label} aria-current="page">{item.label}</span>
        ))}
    </nav>
);

export default Breadcrumbs;
